import React, {Component} from 'react';
import * as FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';

/** @class ImageUploader
 * A component for uploading images to a
 * Firebase storage bucket.
 */
export default class ImageUploader extends Component {
  /** @constructor
    * Creates a new instance of the component
    */
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @function handleChange
    * Handles changes on the file input and
    * submits an updated url to the provided
    * onChange handler
    * @param {InputEvent} event - the event triggering
    * the update.
    */
  handleChange(event) {
    var file = event.target.files[0];
    var key = firebase.database().ref('/uploads').push().key;
    var ref = firebase.storage().ref().child(`/uploads/${key}/${file.name}`);
    this.setState({loading: true});
    ref.put(file).then(()=>{
      ref.getDownloadURL().then((url) => {
        this.setState({loading: false});
        this.props.onUpload(url);
      });
    });
  }
  /** @method handleRemove
    * Removes the image from firebase storage (if held there)
    * and removes the url from the database.
    */
  handleRemove(event) {
    //var ref = firebase.storage().ref().child(this.props.dataURL);
    //console.log('removing image:', this.props.dataURL)
    //ref.delete().catch(err => console.error(err.message));
    this.props.onUpload(null);
  }
  /** @function render
    * Renders the component
    */
  render() {
    const remove = (
      <button onClick={this.handleRemove}>
        <FontAwesome name="times-circle" style={{color: 'red', padding: '0', marginRight: '0.5rem'}} />
        Remove Image
      </button>
    )
    const input = (
      <div className="spinner-box">
        <div className="polaroid">
          <div className="photo-paper">
            <img src={this.props.value} alt="preview" /><br/>
          </div>
        </div>
        <input type="file" name="image" onChange={this.handleChange}/>
        {(this.props.value !== undefined) ? remove : null}
      </div>
    );
    const spinner = (<span><FontAwesome name="spinner" spin={true}/>Loading...</span>);
    return(
      <div>
        <label htmlFor="image">{this.props.name}</label>
        <div className="uploader-input">
          {(this.state.loading) ? spinner : input}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uploaders/image-uploader.js